(function () {
  'use strict';

  function init(card) {
    if (card.dataset.customProductCardInitialized) return;
    card.dataset.customProductCardInitialized = 'true';

    const slideshow = card.querySelector('.custom-product-card__gallery');
    if (!slideshow) return;

    card.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'mouse') return;
      if (typeof slideshow.next === 'function') {
        slideshow.next(undefined, { animate: false });
      }
    });

    card.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse') return;
      if (typeof slideshow.select === 'function') {
        slideshow.select(0, undefined, { animate: false });
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.custom-product-card').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
